import { AutogenLayoutExtBillCommentsQuickInfo } from "./autogen/AutogenLayoutExtBillCommentsQuickInfo";

export class ExtBillCommentsQuickInfo extends AutogenLayoutExtBillCommentsQuickInfo {

}
